import { Group, VisuallyHidden } from "@mantine/core";
import { useTranslation } from "@hooks/useTranslation";

/** A tab title that shows a red dot while the tab holds something that blocks saving. */
export const TabLabel = ({ label, invalid }: { label: string; invalid?: boolean }) => {
    const { t } = useTranslation();
    return (
        <Group gap="xs" wrap="nowrap" component="span">
            <span>{label}</span>
            {invalid && (
                <>
                    <span className="editor-drawer__tab-dot" aria-hidden />
                    <VisuallyHidden>{t("admin.flowConfigs.editor.tabHasErrors")}</VisuallyHidden>
                </>
            )}
        </Group>
    );
};
